import {ReactElement} from "react";

import {prepareStyles} from "src/utils/components";
import {TranslationProvider, Translation} from "src/components/translation";
import LayoutWithSidebar from "src/components/LayoutWithSidebar";

import Sidebar from "./Sidebar";

const strings = require<Translation>('./strings.yaml');


const styles = prepareStyles({
  root: {
    height: '100vh',
  },

});


const App = (props: {
  children?: ReactElement<any>;
}) => {
  return <TranslationProvider translation={strings}>
    <LayoutWithSidebar style={styles.root}
                       sidebarElement={<Sidebar/>}>
      {props.children}
    </LayoutWithSidebar>
  </TranslationProvider>;
};


export default App;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/routes/index.tsx